
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="bg-black/90 backdrop-blur-sm border-b border-amber-500/20 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-amber-400 cursor-pointer" style={{fontFamily: "Pacifico, serif"}}>奇跡のブラックアウト</Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="text-white hover:text-amber-400 transition-colors cursor-pointer">ホーム</Link>
              <Link to="/terms" className="text-white hover:text-amber-400 transition-colors cursor-pointer">利用規約</Link>
              <Link to="/privacy" className="text-amber-400 cursor-pointer">プライバシーポリシー</Link>
              <Link to="/contact" className="text-white hover:text-amber-400 transition-colors cursor-pointer">お問い合わせ</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold text-amber-400 mb-8 text-center">プライバシーポリシー</h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">1. はじめに</h2>
              <p className="leading-relaxed">
                運営（以下「当運営」といいます。）は、「奇跡のブラックアウト」（以下「本アプリ」といいます。）において、利用者の個人情報の保護に関する法令を遵守し、利用者の個人情報を適切に取り扱うことをお約束いたします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">2. 個人情報の定義</h2>
              <p className="leading-relaxed">
                本プライバシーポリシーにおいて「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康診断書の結果その他の身体の特徴に関する情報を指します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">3. 収集する情報</h2>
              <p className="leading-relaxed mb-4">
                当運営は、本アプリの提供に必要な範囲で、以下の情報を収集する場合があります。
              </p>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold text-amber-300 mb-3">3.1 自動的に収集される情報</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li><strong>デバイス情報</strong>：OS、機種、デバイスID、アプリバージョン等</li>
                    <li><strong>利用状況情報</strong>：アプリの起動回数、利用時間、機能の利用状況等</li>
                    <li><strong>技術的情報</strong>：IPアドレス、ブラウザ情報、通信環境等</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-300 mb-3">3.2 広告に関する情報</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li><strong>広告表示情報</strong>：表示された広告の種類、表示回数等</li>
                    <li><strong>広告クリック情報</strong>：広告のクリック回数、クリックした広告の種類等</li>
                    <li><strong>リワード広告情報</strong>：視聴したリワード広告の種類、視聴回数等</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-300 mb-3">3.3 ゲームデータ</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li><strong>ゲーム進行データ</strong>：タップ数、フリーズ回数、統計データ等</li>
                    <li><strong>設定データ</strong>：ゲーム設定、ユーザー設定等</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">4. 情報収集の方法</h2>
              <p className="leading-relaxed mb-4">
                当運営は、以下の方法により情報を収集します。
              </p>
              <ol className="list-decimal pl-6 space-y-2">
                <li><strong>アプリ内での自動収集</strong>：本アプリの利用に伴い自動的に収集</li>
                <li><strong>Firebase Analytics</strong>：Google Firebase Analyticsによる利用状況の分析</li>
                <li><strong>AdMob</strong>：Google AdMobによる広告配信に伴う情報収集</li>
                <li><strong>ローカルストレージ</strong>：デバイス内のローカルストレージへの保存</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">5. 情報の利用目的</h2>
              <p className="leading-relaxed mb-4">
                収集した情報は、以下の目的で利用いたします。
              </p>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold text-amber-300 mb-3">5.1 本アプリの提供・運営</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>本アプリの機能提供</li>
                    <li>本アプリの改善・開発</li>
                    <li>利用者サポート</li>
                    <li>セキュリティの確保</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-300 mb-3">5.2 広告配信</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>適切な広告の配信</li>
                    <li>広告効果の測定・分析</li>
                    <li>リワード広告の提供</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-300 mb-3">5.3 分析・統計</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>利用状況の分析</li>
                    <li>アプリの改善点の特定</li>
                    <li>統計データの作成</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">6. 第三者提供</h2>
              <p className="leading-relaxed mb-4">
                当運営は、以下の場合を除き、収集した個人情報を第三者に提供することはありません。
              </p>
              <ol className="list-decimal pl-6 space-y-2 mb-6">
                <li><strong>利用者の同意がある場合</strong></li>
                <li><strong>法令に基づく場合</strong></li>
                <li><strong>人の生命、身体または財産の保護のために必要がある場合</strong></li>
                <li><strong>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</strong></li>
                <li><strong>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</strong></li>
                <li><strong>AdMobによる広告配信のために必要がある場合</strong></li>
                <li><strong>Firebase Analyticsによる利用状況分析のために必要がある場合</strong></li>
              </ol>

              <div>
                <h3 className="text-xl font-bold text-amber-300 mb-3">6.1 広告配信・分析事業者への提供</h3>
                <p className="leading-relaxed mb-4">
                  本アプリでは、以下の事業者に情報が提供される場合があります。
                </p>
                <div className="bg-gray-800/50 border border-amber-500/20 rounded-lg p-4">
                  <ul className="space-y-3">
                    <li>
                      <strong className="text-amber-300">Google LLC</strong>（AdMob、Firebase Analytics）
                      <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
                        <li>提供する情報：デバイス情報、利用状況情報、広告に関する情報</li>
                        <li>利用目的：広告配信、利用状況の分析</li>
                        <li>プライバシーポリシー：<a href="https://policies.google.com/privacy" className="text-amber-400 hover:text-amber-300 cursor-pointer">https://policies.google.com/privacy</a></li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <p className="leading-relaxed mt-4 text-sm bg-yellow-900/20 border border-yellow-500/30 rounded-lg p-4">
                  <strong>注意</strong>：AdMobおよびFirebase Analyticsは、当運営が直接情報を提供するものではなく、これらのサービスが自動的に情報を収集する仕組みとなっています。利用者は、これらのサービスの利用を停止することはできませんが、アプリの利用を停止することで情報の収集を停止することができます。
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">7. 情報の保存期間</h2>
              <p className="leading-relaxed mb-4">
                当運営は、以下の期間、個人情報を保存します。
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>アプリ利用データ</strong>：アプリのアンインストールまで</li>
                <li><strong>統計データ</strong>：アプリの改善に必要な期間</li>
                <li><strong>広告データ</strong>：広告配信事業者のポリシーに従う</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">8. 情報の管理・保護</h2>
              <p className="leading-relaxed">
                当運営は、個人情報の漏洩、滅失、毀損の防止その他の個人情報の安全管理のため、必要かつ適切な技術的・組織的安全管理措置を講じます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">9. 利用者の権利</h2>
              <p className="leading-relaxed mb-4">
                利用者は、当運営に対して以下の権利を有します。
              </p>
              <ol className="list-decimal pl-6 space-y-2 mb-6">
                <li><strong>開示請求権</strong>：個人情報の開示を求める権利</li>
                <li><strong>訂正・削除請求権</strong>：個人情報の訂正・削除を求める権利</li>
                <li><strong>利用停止・消去請求権</strong>：個人情報の利用停止・消去を求める権利</li>
              </ol>
              <div className="bg-yellow-900/20 border border-yellow-500/30 rounded-lg p-4">
                <p className="leading-relaxed text-sm mb-4">
                  <strong>注意</strong>：Firebase AnalyticsおよびAdMobにより収集・保存される情報については、当運営では直接的な開示、訂正、削除、利用停止を行うことができません。これらの情報に関する権利の行使については、各サービスの提供者（Google LLC）に直接お問い合わせください。
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                  <li><strong>Firebase Analytics</strong>：<a href="https://support.google.com/firebase/answer/6317485" className="text-amber-400 hover:text-amber-300 cursor-pointer">https://support.google.com/firebase/answer/6317485</a></li>
                  <li><strong>AdMob</strong>：<a href="https://support.google.com/admob/answer/6128543" className="text-amber-400 hover:text-amber-300 cursor-pointer">https://support.google.com/admob/answer/6128543</a></li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">10. 未成年者の個人情報</h2>
              <p className="leading-relaxed">
                本アプリは、未成年者を対象としたサービスではありませんが、未成年者が利用する場合、保護者の同意を得ることを推奨します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">11. クッキー・類似技術</h2>
              <p className="leading-relaxed mb-4">
                本アプリでは、以下の技術を使用する場合があります。
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li><strong>Firebase Analytics</strong>：利用状況の分析</li>
                <li><strong>AdMob</strong>：広告配信の最適化</li>
              </ul>
              <p className="leading-relaxed">
                これらの技術により収集される情報は、本プライバシーポリシーに従って取り扱われます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">12. プライバシーポリシーの変更</h2>
              <p className="leading-relaxed">
                当運営は、必要に応じて本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、本アプリ内に掲示した時点から効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">13. お問い合わせ</h2>
              <p className="leading-relaxed mb-4">
                個人情報の取扱いに関するお問い合わせは、以下の方法でお願いいたします。
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>ホームページ</strong>：<Link to="/contact" className="text-amber-400 hover:text-amber-300 cursor-pointer">こちらのお問い合わせページ</Link>からご連絡ください</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">14. 準拠法・管轄裁判所</h2>
              <p className="leading-relaxed">
                本プライバシーポリシーは、日本法に準拠して解釈されるものとし、本プライバシーポリシーに関して紛争が生じた場合には、運営の所在地を管轄する裁判所を専属的合意管轄とします。
              </p>
            </section>

            <div className="text-right mt-12 pt-8 border-t border-amber-500/20">
              <p className="text-gray-400">制定日：2025年09月20日</p>
              <p className="text-gray-400">本プライバシーポリシーは、2025年09月20日から施行されます。</p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-amber-500/20 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400">
            © 2025 奇跡のブラックアウト. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
